import { push } from "connected-react-router"

import { GET_PRODUCERS } from "./Constants"

export const getProducers = ( dispatch, params ) => {
	const withReset = params && params.withReset ? params.withReset : null
  dispatch({ 
		type: GET_PRODUCERS,
		payload: {
			withReset: withReset
		}
	})
}
export const redirect = ( dispatch, params ) => {
	dispatch(push(params))
}
